module.exports = __webpack_public_path__ + "static/media/error-404-colour.803c3242.svg";